import { getImageUrlByNewURL } from "@/utils/getImageUrl.js";
import { notification } from "ant-design-vue";
// [FIX 2026-10-15] antd 改按需引入后，命令式 API 的样式不再被自动注入：
//   unplugin-vue-components 只处理「模板里的 <a-xxx>」，而 notification 是 JS 调用，
//   模板里没有它 ⇒ CSS 不进包 ⇒ 提示弹出但没有定位/背景/z-index ⇒ 肉眼不可见。
//   这里显式补上该组件的样式入口（仅此一个组件的 CSS，体积影响极小）。
import 'ant-design-vue/es/notification/style/css'
import { h, watch, ref, nextTick } from 'vue'

const noticeCount = ref(0)

watch(
  () => noticeCount.value,
  (newVal) => {
    console.log('noticeCount change',newVal);
    nextTick(() => {
      // console.log('count;', noticeCount.value);

      //all notice element in document 
      const cusNotices = document.getElementsByClassName("cus-notice")

      console.log('cuslen:', cusNotices.length);
      
      // console.log('isclear;',isClearAll);
      if (cusNotices.length > 1) {
        //create clear all  element
        console.log('clear all');

        //只显示一个提示
        clearAllNotices()
      } else {
        // console.log('remove', noticeCount.value);
        const isClearAll = document.querySelector('.clear')
        if (isClearAll) {
          const wrap = document.querySelector('.clear').parentNode
          wrap.removeChild(isClearAll)
        }
      }

    })
  }
);

//显示清除所有notice 按钮
function clearAllNotices() {
  const isClearAll = document.querySelector('.clear')
  const wrap = document.querySelector('.cus-notice').parentNode
  if (isClearAll) {
    wrap.removeChild(isClearAll)
  }
  const list = wrap.children
  //get last child of list
  const o = list[list.length - 1]

  //create closeAll dom
  const e = document.createElement('div')
  //add click event
  e.addEventListener('click', () => {
    console.log('hide all is click');
    noticeCount.value = 0
    e.parentNode.innerHTML = ''
  })
  e.className = 'clear'
  e.innerHTML = 'Hide all'
  wrap.insertBefore(e, o.nextSibling)
}


/**
 * 全部提示
 * @param {*} type 提示类型 s=success  f=fail  w=warning
 * @param {*} options 传递的参数对象
 */
export default function (type = 's', options) {
  notification.config({
    placement: options.placement||'topRight',
    duration: 2,
    // key:u.nc,
  })

  //判断当前页面是否有弹框,如果有,则不再显示,如果没有则执行弹框提示
  const isHasNotice = document.querySelectorAll('.cus-notice')
  const isHasNoticeClass = document.getElementsByClassName('cus-notice')
  // console.log('sel;',isHasNotice.length);
  // console.log('class;',isHasNoticeClass.length);

  if(isHasNotice.length>0){
    // return 
    //超出1个提示时
    // isHasNotice = isHasNotice.slice(-1)
    // console.warn('has notice',isHasNotice);
    // console.error('has notice',isHasNotice.slice(-1));

    // 遍历除了最后一个以外的所有元素
    isHasNotice.forEach((notice, index) => {
      if (index < isHasNotice.length) {
          notice.remove(); // 删除该弹框
      }
  });

  }

  //成功提示
  if (type == 's') {
    notification.success({
      top:'2.5rem',
      message: h('div', {
        class: 'ntitle',
        style: {
          color: '#3fd03b'
        }
      }, 'SUCCESS'),
      description: options.desc,
      class: 'cus-notice',
      style: {
        background: 'linear-gradient(90deg, #112F15 0%, #1B2031 100%)',
      },
      icon: () =>
        h("img", {
          src: getImageUrlByNewURL("systemicon/notice_success.png"),
          style: "color: #108ee9",
          class: "notice-icon",
        }),
      onClose: () => {
        // console.log('success notice is auto close');
        noticeCount.value--
      }
    })
  }

  //失败提示
  if (type == 'f') {
    notification.error({
      top:'2.5rem',
      message: h('div', {
        class: 'ntitle',
        style: {
          color: '#d03b68'
        }
      }, 'Oops!'),
      description: options.desc,
      class: 'cus-notice',
      style: {
        background: 'linear-gradient(90deg, #2f1117 0%, #1b2031 100%)'
      },
      icon: () =>
        h("img", {
          src: getImageUrlByNewURL("systemicon/notice_error.png"),
          style: "color: #108ee9",
          class: "notice-icon",
        }),
      onClose: () => {
        // console.log('error notice is auto close');
        noticeCount.value--
      }
    })
  }

  //警告提示（2026-09-24 新增：交易链接失效等提醒）
  if (type == 'w') {
    notification.warning({
      top:'2.5rem',
      message: h('div', {
        class: 'ntitle',
        style: {
          color: '#f5a623'
        }
      }, 'NOTICE'),
      description: options.desc,
      class: 'cus-notice',
      style: {
        background: 'linear-gradient(90deg, #2f2312 0%, #1b2031 100%)'
      },
      icon: () =>
        h("img", {
          src: getImageUrlByNewURL("systemicon/notice_error.png"),
          style: "color: #f5a623",
          class: "notice-icon",
        }),
      onClose: () => {
        noticeCount.value--
      }
    })
  }

  Promise.resolve(() => {
  }).then(res => {
    // clearAllNotices()
  })

  //触发一个提示,累加一次,通过监听noticeCount 用来控制是否显示 清除所有元素按钮
  noticeCount.value++

}

